/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_AssetInputs */

const en_edit_asset = /** @type {(inputs: Edit_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Asset`)
};

const es_edit_asset = /** @type {(inputs: Edit_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar activo`)
};

const fr_edit_asset = /** @type {(inputs: Edit_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier le bien`)
};

const de_edit_asset = /** @type {(inputs: Edit_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset bearbeiten`)
};

const ja_edit_asset = /** @type {(inputs: Edit_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アセットを編集`)
};

const zh_edit_asset = /** @type {(inputs: Edit_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑资产`)
};

const ar_edit_asset = /** @type {(inputs: Edit_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعديل الأصل`)
};

const id_edit_asset = /** @type {(inputs: Edit_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Aset`)
};

const it_edit_asset = /** @type {(inputs: Edit_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifica Risorsa`)
};

const ru_edit_asset = /** @type {(inputs: Edit_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Редактировать ресурс`)
};

const pt_edit_asset = /** @type {(inputs: Edit_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar Ativo`)
};

const ko_edit_asset = /** @type {(inputs: Edit_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`에셋 편집`)
};

/**
* | output |
* | --- |
* | "Edit Asset" |
*
* @param {Edit_AssetInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const edit_asset = /** @type {((inputs?: Edit_AssetInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_AssetInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_edit_asset(inputs)
	if (locale === "es") return es_edit_asset(inputs)
	if (locale === "fr") return fr_edit_asset(inputs)
	if (locale === "de") return de_edit_asset(inputs)
	if (locale === "ja") return ja_edit_asset(inputs)
	if (locale === "zh") return zh_edit_asset(inputs)
	if (locale === "ar") return ar_edit_asset(inputs)
	if (locale === "id") return id_edit_asset(inputs)
	if (locale === "it") return it_edit_asset(inputs)
	if (locale === "ru") return ru_edit_asset(inputs)
	if (locale === "pt") return pt_edit_asset(inputs)
	return ko_edit_asset(inputs)
});